import {requestCommon} from '@/libs/axios'

/*获取分销活动相应的默认配置参数信息*/
 export const distributionActivity =  data=>requestCommon.post('/paralegal/lawyer/distribution/activity',data)

/*获取律师的邀请活动实时数据*/
export const distributionInfo =  type=>requestCommon.post(`/paralegal/lawyer/distribution/Info/${type}`)

/*活动页面轮播信息*/
export const distributionCarousel =  data=>requestCommon.post('/paralegal/lawyer/distribution/carousel',data)

/*领取奖励信息*/
export const distributionReceive =  data=>requestCommon.post('/paralegal/lawyer/distribution/receive',data)

/*律师渠道统计邀请落地页pv统计*/
export const lawyerChannelBuryPv =  data=>requestCommon.post('/paralegal/lawyerChannelBury/buryPv',data)

//获取微信urlScheme
export const urlSchemeGenerate = (data,header={}) => requestCommon.post('/core/user/wechat/urlScheme/generate', data,header)
